<template>
    <div class="forum-main" v-title="'工业服务未来发展论坛'" v-if="details">
        <div class="link-live" @click="$router.push({ path: '/live'});">主会场</div>
        <div class="forum-box">
            <img class="title" src="@/assets/forum/forum-title.png" alt="">
            <img class="tips" src="@/assets/forum/forum-min-title.png" alt="">
            <p class="start-time">2022-03-26 14:00开启</p>
            <img class="label" src="@/assets/forum/forum-label.png" alt="">
        </div>
        <div class="forum-gift">
            <div class="gift-child">
                <ul>
                    <li>
                        <div>
                            <div>
                                <label for="">好礼一</label>
                                <p>电子版白皮书免费下载</p>
                            </div>
                            <img src="@/assets/forum/forum-bps.png" alt="">
                        </div>
                    </li>
                    <li>
                        <div>
                            <div>
                                <label for="">好礼二</label>
                                <p>得锦鲤号码 赢万元现金</p>
                            </div>
                            <img src="@/assets/forum/forum-jl.png" alt="">
                        </div>
                        <p class="jl-num" v-if="details.LotteryYards">锦鲤号码：{{details.LotteryYards}}</p>
                    </li>
                    <li>
                        <div>
                            <div>
                                <label for="">好礼三</label>
                                <p>论坛当场福利 神秘惊喜</p>
                            </div>
                            <img src="@/assets/forum/forum-jx.png" alt="">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="forum-btn">
            <p>已有{{details.SharedCount}}人预约</p>
            
            <div class="tips" v-if="details.IsSubscribe">论坛正式开始时，可享以上全部好礼<br/>请留意短信通知。</div>
            <!-- <div class="btn-no" v-if="details.IsSubscribe">
                <button @click="onShowShareYi">已预约 立即分享</button>
            </div> -->
            <div class="btn-zc" v-if="details.IsSubscribe">
                <button class="up" @click="eleBtn">下载白皮书</button>
                <button class="zc" @click="onShowShareYi">已预约 继续分享</button>
            </div>
            <div class="btn-no" v-else>
                <button @click="onShowShare">立即预约</button>
            </div>
        </div>
        <div class="guest-box">
            <div class="column orz-one">
                <img class="guest-label" src="@/assets/forum/forum-label-ztjb.png" alt="">
                <ul class="column-list">
                    <li>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                    </li>
                    <li>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                    </li>
                    <li>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                    </li>
                </ul>
            </div>
            <div class="column orz-two">
                <img class="guest-label" src="@/assets/forum/forum-label-yztl.png" alt="">
                <ul class="column-list">
                    <li>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                    </li>
                    <li>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                    </li>
                    <li>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                    </li>
                </ul>
            </div>
            <div class="column orz-three">
                <img class="guest-label" src="@/assets/forum/forum-label-tyjb.png" alt="">
                <ul class="column-list">
                    <li>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                    </li>
                    <li>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                    </li>
                    <li>
                        <div class="items-left">
                            <h3>工业速派服务灯塔工业速派服务灯塔</h3>
                            <p>速派速派速派速派速派速派</p>
                        </div>
                        <div class="items-right">
                            <img src="~/static/image/cover.png" alt="" />
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <van-share-sheet
            v-model="showShare"
            title="分享预约"
            :options="options"
            @select="onSelect"
        /> -->
        <div class="wx-mask" v-if="showShare" @click="showShare=false"></div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import { 
    GetForumSubscribeInfo,
    DoForumSubscribeCallBack,
} from "@/common/api.js";
import bridge from '@/common/dsbridge.js';
let u = navigator.userAgent;
let ua = navigator.userAgent.toLowerCase();
export default {
    data(){
        return {
            appUserInfo: null,              //app里的用户信息
            userid: 0,                 //app里的用户id 不带p
            companyId: 0,
            isWeb: true,                    //是否是浏览器 true 是 false 否
            showShare: false,

            details: null
        }
    },
    created() {
        this.isWeb=typeof(bridge.call('getUserInfo'))==='undefined'?true:false;
        this.getUserInfo();
    },
    computed: {
        ...mapState({
            userData: state => state.userData,
            createConfig: state => state.createConfig,
        }),
    },
    mounted() {
        let that = this;
        bridge.register('notifyLoginSuccess', function () {
            that.getUserInfo();
        });
        bridge.register('shareSuccessBack', function () {
            that.shareSuccessBack()
        });
        this.wxShare2()
    },
    methods:{
        getUserInfo(){
            let self = this
            let info = bridge.call('getUserInfo') || null;
            if(info) {
                this.appUserInfo = JSON.parse(info).isLogin?JSON.parse(info):null;
                if(this.appUserInfo) {
                    if (this.appUserInfo.userId.indexOf('p') === 0) {
                        this.userid = Number(this.appUserInfo.userId.substr(1));
                    }else if(this.appUserInfo.userId.indexOf('e') === 0){
                        this.companyId = Number(this.appUserInfo.userId.substr(1));
                    }
                }
            }
            setTimeout(function(){
                self.getConfigDetails()
            },500)
        },
        getConfigDetails(){
            let data = {}
            if(this.appUserInfo && !this.isWeb) {
                if(this.userid) {
                    data.UserId = this.userid
                }else{
                    data.CompanyId = this.companyId
                }
            }else if(this.userData && this.isWeb) {
                if(this.userData && this.userData.UserId){
                    data.UserId=this.userData.UserId;
                }else if(this.userData && this.userData.CompanyId){
                    data.CompanyId=this.userData.CompanyId;
                }
            }
            GetForumSubscribeInfo(data).then(res=>{
                if(res.Result != 1) {
                    return this.$toast('请重新获取');
                }
                this.details = res.Data
            })
        },
        onShowShare(){
            if(!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                return this.$toast('请在移动端查看！');
            }
            if(!this.appUserInfo && !this.isWeb) {
                return bridge.call('launchLogin');
            }
            if(!this.userData && this.isWeb) {
                return this.$router.push({ path: "/login/personLogin",query:{link:'forum'} });
            }
            if(this.appUserInfo) {
                bridge.call('userShare',`{
                    "shareUrl":"${window.location.origin}/#/forum?link=forum",
                    "shareTitle":"预约有礼-工业服务未来发展论坛",
                    "shareDesc":"暨《中国工业服务产业发展白皮书》发布会",
                    "shareIcon":"https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/icon/share.png",
                    "isShareWxSmallProgram":false
                }`);
            }else{
                this.shareSuccessBack()
                // this.showShare=true
            }
        },
        // 已经预约再次分享
        onShowShareYi(){
            if(this.appUserInfo) {
                bridge.call('userShare',`{
                    "shareUrl":"${window.location.origin}/#/forum?link=forum",
                    "shareTitle":"预约有礼-工业服务未来发展论坛",
                    "shareDesc":"暨《中国工业服务产业发展白皮书》发布会",
                    "shareIcon":"https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/icon/share.png",
                    "isShareWxSmallProgram":false
                }`);
            }else{
                this.showShare = true
                // window.location.href = 'https://wx.insupai.com/download/download.html';
            }
        },
        
        shareSuccessBack(){
            if(this.details.IsSubscribe){ 
                return
            }
            let data = {}
            if(this.appUserInfo && !this.isWeb) {
                if(this.userid) {
                    data.UserId = this.userid
                }else{
                    data.CompanyId = this.companyId
                }
            }else if(this.userData && this.isWeb) {
                if(this.userData && this.userData.UserId){
                    data.UserId=this.userData.UserId;
                }else if(this.userData && this.userData.CompanyId){
                    data.CompanyId=this.userData.CompanyId;
                }
            }
            DoForumSubscribeCallBack(data).then(res=>{
                if(res.Result != 1) {
                    return this.$toast('请重新获取');
                }
                this.$toast('预约成功！');
                this.details = res.Data
            })
        },
        // 点击下载白皮书
        eleBtn(){
            let url = this.details.DownLoadUrl
            if (u.indexOf('iPhone') > -1) {
                if(this.appUserInfo) {
                    bridge.call('userShare',`{
                        "shareUrl":"${url}",
                        "shareTitle":"预约有礼-工业服务未来发展论坛",
                        "shareDesc":"暨《中国工业服务产业发展白皮书》发布会",
                        "shareIcon":"https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/icon/share.png",
                        "isShareWxSmallProgram":false
                    }`);
                }else{
                    window.location.href = url
                }
            }else if(u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
                if(this.appUserInfo) {
                    bridge.call('downloadFile',`${url}`);
                }else{
                    window.location.href = url
                }
            }else{
                window.location.href = url
            }
        },
    },
    
}
</script>
<style lang="scss">
    @import '~@/style/_base.scss';
    .forum-main {
        width: 10rem;
        @include bg('~@/assets/forum/forum-bg.png');
        background-size: contain;
        background-position: center top;
        min-height: 100vh;
        background-color: #000964;
        overflow: hidden;
        padding-bottom: px2rem(40px);
        margin: 0 auto;
        position: relative;
        .link-live {
            background: #FFA300;
            width: px2rem(125px);
            height: px2rem(60px);
            border-radius: px2rem(30px) 0 0 px2rem(30px);
            text-align: center;
            font-size: px2rem(26px);
            color: #fff;
            font-weight: 400;
            position: absolute;
            right: 0;
            top: px2rem(30px);
            line-height: px2rem(60px);
            padding-left: px2rem(15px);
        }
        .forum-box {
            min-height: px2rem(644px);
            padding-top: px2rem(72px);
            padding-left: px2rem(52px);
            padding-right: px2rem(52px);
            img {
                display: block;
                max-height: auto;
                width: 100%;
            }
            img.title {
                margin: 0 auto px2rem(22px);
            }
            img.tips {
                width: px2rem(608px);
            }
            img.label {
                margin: px2rem(67px) auto 0;
                width: px2rem(260px);
            }
            .start-time {
                font-size: px2rem(28px);
                font-weight: bold;
                text-align: center;
                line-height: px2rem(30px);
                color: #fff;
                margin-top: px2rem(42px);
            }
        }
        .forum-gift {
            margin-left: px2rem(48px);
            margin-right: px2rem(48px);
            border: px2rem(1px) solid #0F4BEB;
            border-radius: px2rem(20px);
            .gift-child {
                margin: px2rem(6px);
                background-color: #0500A2;
                min-height: px2rem(410px);
                border-radius: px2rem(20px);
                position: relative;
                box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.4);
                ul {
                    padding-left: px2rem(34px);
                    padding-right: px2rem(34px);
                    color: #ffffff;
                    li {
                        min-height: px2rem(204px);
                        padding-left: px2rem(18px);
                        padding-right: px2rem(28px);
                        border-bottom: 1px solid #0F4BEB;
                        > div {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: px2rem(34px);
                            padding-top: px2rem(56px);
                            img {
                                display: block;
                                width: px2rem(116px);
                                height: px2rem(98px);
                            }
                            label {
                                color: #FFE400;
                                line-height: px2rem(40px);
                            }
                            p {
                                padding-top: px2rem(14px);
                                line-height: px2rem(48px);
                            }
                        }
                        .jl-num {
                            font-size: px2rem(24px);
                            line-height: px2rem(44px);
                            padding-bottom: px2rem(49px);
                        }

                    }
                    li:last-child{
                        border-bottom: none;
                    }
                }
            }
        }
        .forum-btn {
            margin-left: px2rem(48px);
            margin-right: px2rem(48px);
            p {
                font-size: px2rem(24px);
                text-align: right;
                color: #ffffff;
                line-height: px2rem(84px);
            }
            .tips {
                text-align: center;
                font-size: px2rem(28px);
                color: #ffffff;
                margin-bottom: px2rem(32px);
            }
            .btn-zc {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: px2rem(40px);
                button {
                    height: px2rem(80px);
                    font-size: px2rem(34px);
                    color: #ffffff;
                    font-weight: 500;
                    border-radius: px2rem(40px);
                }
                button.up {
                    width: px2rem(252px);
                    border: 1px solid #FFFFFF;
                    background: none;
                }
                button.zc {
                    width: px2rem(300px);
                    background: #FFA300;
                }
            }
            .btn-no {
                margin-bottom: px2rem(40px);
                button {
                    width: 100%;
                    background: #FFA300;
                    border-radius: px2rem(40px);
                    height: px2rem(80px);
                    color: #ffffff;
                    font-size: px2rem(34px);
                    font-weight: 500;
                }
            }

        }
        .guest-box {
            padding: px2rem(62px) px2rem(54px) 0;
            .column {
                position: relative;
                z-index: 2;
                caret-color: transparent;
                &::after {
                    content: '';
                    width: px2rem(136px);
                    height: px2rem(112px);
                    background-image: url('~@/assets/forum/bulingbuling.png');
                    background-repeat:no-repeat;
                    background-size: cover;
                    position: absolute;
                    z-index: -1;
                }
                &::before {
                    content: '';
                    width: px2rem(136px);
                    height: px2rem(112px);
                    background-image: url('~@/assets/forum/bulingbuling.png');
                    background-repeat:no-repeat;
                    background-size: cover;
                    position: absolute;
                    z-index: -1;
                }
                &.orz-one::after {
                    left: 0;
                    top: 30%;
                }
                &.orz-one::before {
                    right: px2rem(-54px);
                    top: 0;
                }
                &.orz-two::after {
                    left: 50%;
                    top: 60%;
                }
                &.orz-two::before {
                    left: 20%;
                    top: 20%;
                }
                &.orz-three::after {
                    left: 50%;
                    bottom: 0;
                }
                &.orz-three::before {
                    left: 20%;
                    top: 20%;
                }
                .guest-label {
                    display: block;
                    margin: 0 auto px2rem(58px);
                    width: px2rem(226px);
                    height: px2rem(38px);
                }
                .column-list {
                    li {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        color: #fff;
                        padding-bottom: px2rem(66px);
                        .items-left {
                            width: px2rem(406px);
                            h3 {
                                font-size: px2rem(34px);
                                font-weight: 500;
                                line-height: px2rem(46px);
                                margin-bottom: px2rem(10px);
                            }
                            p {
                                font-size: px2rem(28px);
                                font-weight: 400;
                                line-height: px2rem(40px);
                            }
                        }
                        .items-right {
                            width: px2rem(194px);
                            height: px2rem(192px);
                            border: 1px solid #0F4BEB;
                            border-radius: 50%;
                            padding: 10px;
                            img {
                                display: block;
                                width: 100%;
                                height: 100%;
                                border-radius: 50%;
                            }
                        }
                    }
                }
            }
        }
    }
    .wx-mask{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        @include bg('~static/image/cover.png');
        background-size: cover;
        background-position: top center;
    }
</style>